import Cookies from "js-cookie";
import store from "./../store/";
import router from "./../router";
import {
  SIDEBAR_ITEMS,
  ROUTE_GUEST,
  ROUTE_STUDENT,
  ROUTE_BUSINESS_STUDENT
} from "../assets/constant";

export default async function Auth({ next, to }) {
  let token = await Cookies.get("rsr-user-token");
  let student = await Cookies.get("student-permissions");

  // await Cookies.remove("rsr-user-token");
  if (student !== "student") {
    if (token) {
     await store.dispatch("auth/getUser");
    // console.log(store.state.auth.user.status === 0);
     if(store.state.auth.user.status === 0){
        await Cookies.remove("rsr-user-token");
        router.push("/admin/login");
        return;
     }

      if (!ROUTE_GUEST.includes(to.name)) {
        const permissions = store.getters["auth/permissions"];
        let navRouter = SIDEBAR_ITEMS.filter(item => {
          return item.name === to.name;
        });
        if (
          navRouter.length > 0 &&
          permissions.includes(navRouter[0].permission)
        ) {
          next();
        } else {
          next({ name: "QuestionList" });
        }
        return;
      }
    } else if (!ROUTE_GUEST.includes(to.name)) {
      router.push("/login");
    }
    return next();
  } else {
    if (token) {
      await store.dispatch("auth/getStudent");
      if (typeof store.getters["auth/user"].business_id === "number") {
        if (!ROUTE_BUSINESS_STUDENT.includes(to.name)) {
          console.log("To name", to.name);
          next({ name: "MyExam" });
        } else {
          next();
        }
        return;
      }

      if (!ROUTE_STUDENT.includes(to.name)) {
        const permissions = store.getters["auth/permissions"];
        let navRouter = SIDEBAR_ITEMS.filter(item => {
          return item.name === to.name;
        });
        if (
          navRouter.length > 0 &&
          permissions.includes(navRouter[0].permission)
        ) {
          next();
        } else {
          next({ name: "ExamStudent" });
        }
        return;
      }
    } else if (!ROUTE_STUDENT.includes(to.name)) {
      router.push("/login");
    }
    return next();
  }
}
